import moment from 'moment';
import get from 'lodash/get';
import first from 'lodash/first';
import last from 'lodash/last';
import min from 'lodash/min';
import max from 'lodash/max';
import map from 'lodash/map';
import compact from 'lodash/compact';
function getSnaqImportsDateRange(phiSet) {
    let minSnaqImportTimestamp = null;
    let maxSnaqImportTimestamp = null;
    const documents = get(phiSet, 'imports.snaq.documents');
    if (!documents) {
        return {
            minSnaqImportTimestamp,
            maxSnaqImportTimestamp
        };
    }
    const firstImport = first(documents);
    if (firstImport) {
        minSnaqImportTimestamp = firstImport.minResultDate;
    }
    const lastImport = last(documents);
    if (lastImport) {
        maxSnaqImportTimestamp = lastImport.maxResultDate;
    }
    return {
        minSnaqImportTimestamp,
        maxSnaqImportTimestamp
    };
}
export function calculateDateRanges(phiSet, dataType = 'BGM') {
    const summary = get(phiSet, dataType === 'BGM' ? 'summaryData' : 'cgmSummaryData');
    const minReadingsTimestamp = get(summary, 'minReadingsTimestamp');
    const maxReadingsTimestamp = get(summary, 'maxReadingsTimestamp');
    const { minSnaqImportTimestamp, maxSnaqImportTimestamp } = getSnaqImportsDateRange(phiSet);
    const minPhiTimestamp = min(compact([
        minReadingsTimestamp,
        minSnaqImportTimestamp
    ]));
    const maxPhiTimestamp = max(compact([
        maxReadingsTimestamp,
        maxSnaqImportTimestamp
    ]));
    const maxMoment = maxPhiTimestamp ? moment.unix(maxPhiTimestamp).utc() : moment().utc();
    maxMoment.endOf('day');
    const defaultStartMoment = maxMoment.clone().startOf('day').subtract(14, 'days').add(1, 'day');
    const minMoment = minPhiTimestamp ? moment.unix(minPhiTimestamp).utc().startOf('day') : defaultStartMoment;
    return {
        defaultStartMoment,
        minMoment,
        maxMoment
    };
}
export function calculateDateRangesFromReadings(readings) {
    const minTimestamp = min(map(readings, (reading)=>reading.timestamp));
    const maxTimestamp = max(map(readings, (reading)=>reading.timestamp));
    const maxMoment = maxTimestamp ? moment.unix(maxTimestamp).utc() : moment().utc();
    maxMoment.endOf('day');
    const defaultStartMoment = maxMoment.clone().startOf('day').subtract(14, 'days').add(1, 'day');
    const minMoment = minTimestamp ? moment.unix(minTimestamp).utc().startOf('day') : defaultStartMoment;
    return {
        defaultStartMoment,
        minMoment,
        maxMoment
    };
}
